export default "/profile/images/search-alt-svgrepo-com.svg?bb0ff760bdf730642c60554e72ceabe1";